import React, { useEffect } from 'react'

import {
  useRecordingData,
  useRecordingPlaybackState,
  useRecordingPlaybackStateObserver
} from '../../hooks'

const RecordingParticipantMedia = React.memo(({ media }) => {
  const playbackStateObserverRef = useRecordingPlaybackStateObserver()
  const videoRef = React.useRef()

  useEffect(() => {
    const stateObserver = playbackStateObserverRef.current
    const videoElem = videoRef.current

    stateObserver.registerMediaElem(media, videoElem)

    return () => {
      stateObserver.unregisterMediaElem(media)
    }
  }, [playbackStateObserverRef, videoRef, media])

  return (
    <video
      ref={videoRef}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      }}
      preload='auto'
      playsInline
      src={`${process.env.API_URL}/recordings/${media.sid}/media`}
    />
  )
})
RecordingParticipantMedia.displayName = 'RecordingParticipantMedia'

export const useIsParticipantVideoEnabled = (participantId) => {
  const { recording } = useRecordingData()
  const { genesis, elapsed } = useRecordingPlaybackState()

  const media = recording.media
    .filter((m) =>
      participantId === 'SCREEN'
        ? m.type === 'SCREEN'
        : m.user === participantId
    )
    .find((m) => {
      return m.start - genesis <= elapsed && elapsed < m.end - genesis
    })

  return {
    enabled: !!media,
    media
  }
}

export default RecordingParticipantMedia
